<template>
	<component :is="componentName" :field="field" :index="index" @update="handleUpdate" />
</template>

<script setup>
import { computed } from 'vue';
import ItemInput from './item-input.vue';
import ItemRadio from './item-radio.vue';
import ItemCheckbox from './item-checkbox.vue';
import ItemImage from './item-image.vue';
import ItemFile from './item-file.vue';

const props = defineProps({
	field: {
		type: Object,
		required: true
	},
	index: {
		type: Number,
		required: true
	}
});

const emit = defineEmits(['update']);

const componentName = computed(() => {
	const type = props.field.type;
	switch (type) {
		case 1:
			return ItemRadio;
		case 2:
			return ItemCheckbox;
		case 3:
			return ItemImage;
		case 5:
			return ItemFile;
		case 0:
		default:
			return ItemInput;
	}
});

const handleUpdate = value => {
	emit('update', { index: props.index, value });
};
</script>
